import React, { FunctionComponent } from "react";
import HiggIconImage from "./HiggIconImage.png";

const HiggIcon: FunctionComponent = () => {
	return (
		<img
			height={27.35}
			src={HiggIconImage}
			width={56}
		/>
	);
};

export default HiggIcon;